// extracted by mini-css-extract-plugin
export default {"wrapper":"search-item_wrapper__AvtAD","tooltip":"search-item_tooltip__8RUUK","container":"search-item_container__ADsBD"};